import { string, object } from 'yup';

const schema = object().shape({
  email: string().required('requiredField').email('invalidEmailAddress')
});

export default schema;